import INPUT_LENTTHS from '@/const/validations';

const MAX_NAME_LENGTH = INPUT_LENTTHS.MAXIMUM_175;
export {
  MAX_NAME_LENGTH,
};
